import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { MdmCommand } from '@rocksoft/mdm-sdk-v2';

export type CommandContentState = EntityState<MdmCommand>;

export function selectIdFromCommandContent(commandContent: MdmCommand): string {
  return commandContent.commandUUID;
}

export const adapter: EntityAdapter<MdmCommand> = createEntityAdapter<MdmCommand>({
  selectId: selectIdFromCommandContent,
});

export const initialState: CommandContentState = adapter.getInitialState();
